/** @module csi/widget/_svg/AddPageDropDownGridMenuItem */
define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"csi/image/_base",
	"csi/reflection",
	"dojo/text!./resources/AddPageDropDownGridMenuItem.html"
], function(declare,_WidgetBase,_TemplatedMixin,csiImage,reflection,template){
	return declare([_WidgetBase, _TemplatedMixin], {
		templateString: template,

		/** onDblClick extension point */
		onDblClick: function() { },

		/** double click event for each grid menu item */
		_onDblClick: function() {
			this.onDblClick();
		},
	});
});
